{
  "startNew": "Start New",
  "table": {
    "createdAt": "Ran At",
    "completedAt": "Completed At",
    "state": "State",
    "files": "Files",
    "organization": "Organization"
  },
  "state": {
    "CANCELED": "Canceled",
    "COMPLETED": "Completed",
    "DRAFT": "Draft",
    "REQUESTED": "Requested"
  },
  "allocationFile": "Allocations",
  "ptfAllocationFile": "PTF Allocations",
  "generating": "Generating",
  "reviewTrades": "Review Trades",
  "updateTrades": "Update Trade Fills",
  "reviewTradeAllocations": "Review Trade Allocations",
  "updatePTFTrades": "Update PTF Trade Fills",
  "reviewPTFTradeAllocations": "Review PTF Trade Allocations",
  "completed": "Completed",
  "generatingDescription": "Trades are being generated now...",
  "rebalanceOn": "Rebalance on",
  "rebalanceCanceled": "Rebalance is canceled, go back to start a new one.",
  "buyTradeFile": "Buy Trade File",
  "sellTradeFile": "Sell Trade File",
  "mutualFundTradeFile": "Mutual Fund Trade File",
  "buySellTradeFile": "Buy/Sell Trade File",
  "ptfBulkTradeFile": "PTF Bulk Trade File",
  "tradeViaFix": "Trade Via FIX",
  "bulkBUYTrades": "Bulk Buy Trades",
  "bulkSELLTrades": "Bulk Sell Trades",
  "bulkMutualFundBUYTrades": "Bulk Mutual Fund Buys",
  "bulkMutualFundSELLTrades": "Bulk Mutual Fund Sells",
  "amountValue": "Value",
  "cancelRebalanceTrades": "Cancel Rebalance Trades",
  "rebalanceCompleted": "Rebalance Completed",
  "allPricesNotUpdated": "All prices are not updated yet",
  "pasteFromExcel": "Copy/Paste from Excel",
  "orderOfContent": "Ensure columns are in order of ticker, price, quantity",
  "cancelConfirmationDialog": "Before you cancel, ensure that you have not sent the bulk trades files. If you have already sent the bulk trade files, the system will throw an ERROR, as all of those trades have been sent to the custodian.",
  "cancelTriggeredMessage": "Cancellation of Rebalance trades, has been triggered!",
  "discrepancyConfirmationDialog": {
    "title": "Discrepancies in Bulk Trades",
    "text": "There are relevant discrepancies in the allocated quantities or prices. Are you sure you want to proceed?"
  },
  "orderOfPortfolioContent": "Ensure columns are in order of ticker and percentage",
  "generate": "Generate",
  "bulkTraderOn": "Bulk Traded on",
  "bulkTradeRunCompleted": "Bulk Trade Completed",
  "bulkTradeRunCanceled": "Bulk Trade Run Canceled",
  "saveTradesMessage": "Save your trades to continue.",
  "securitiesWereNotFound": "Securities were not found: {{securities}}",
  "dialog": {
    "title": "Bulk Trade Request"
  },
  "security": "Security",
  "price": "Price",
  "quantity": "Quantity",
  "save": "Save",
  "update": "Update",
  "cancel": "Cancel",
  "back": "Back",
  "next": "Next",
  "cancelBulkTradeRunTrades": "Cancel Bulk Trade Run Trades"
}
